"use client";
import { faCommentDots } from "@fortawesome/pro-solid-svg-icons";

import Button from "@/components/button";
import IfUserIs from "@/components/if-user-is";
import CreateThread from "@/components/modal/components/create-thread";
import { useModal } from "@/hooks/use-modal";

const CreateThreadButton = () => {
  const { openModal } = useModal();
  return (
    <IfUserIs signedIn>
      <Button
        onClick={() => openModal(() => <CreateThread />)}
        icon={faCommentDots}
        type="positive"
      >
        Create a new thread
      </Button>
    </IfUserIs>
  );
};

export { CreateThreadButton };
